module.exports = {"pageTitleText":"凭证申请","serverName":"域名","sslProvider":"SSL凭证供应商","queues":"伫列","fastEntry":"快速通道","cnameAllowList":"白名单","success":"成功","black":"黑名单","objId":"物件 ID","requestSSLState":"申请状态","collectSSLState":"收集状态","addToQueueDate":"新增至伫列的时间","taskAction":"操作名称","requestAttemptCount":"申请次数","requestSSLDate":"申请日期","requestSSLErrMsg":"申请错误信息","requestSSLOrderNumber":"申请编号","requestSSLlValidateFileName":"申请验证档名","collectAttemptCount":"收集次数","collectSSLDate":"收集日期","collectSSLErrMsg":"收集错误讯息","certkeyRaw":"凭证","certpemRaw":"私钥","queueState":"伫列状态"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/certsapply.json
// module id = KTIJ
// module chunks = 3